/*
 * az-name-walker.js — AZO gallina-names-20260927
 * Owner ruling 27 Sep 2026: every product-name word renders lowercase in the
 * Gallina typeface, in titles AND running text, on BS (/) and /en/.
 * The few central Liquid emission points (PDP title, product cards, cart
 * drawer/cart page line items) already wrap the name server-side in
 * snippets/az-name.liquid. This script is the safety net for hardcoded
 * copy elsewhere in theme sections/blocks (story copy, FAQ text, etc.).
 * It only changes what is WRAPPED for visual styling — it never edits the
 * underlying text nodes' content, so nothing here touches SEO/meta/JSON-LD.
 * Idempotent: skips text already inside .az-name, safe to re-run.
 */
(function () {
  "use strict";

  var NAMES = [
    "TIFAWT", "TAFUKT", "AFOULKI", "ANU", "ALJIG", "AZGGAGH",
    "ANNAY", "SANOUJ", "LHRIR", "IHLA", "AMAAN", "TISLIT",
    "AKNARI", "AUGU", "AZZAR", "BELDI", "TAWENZA", "TAYRI", "TIFAWIN", "SIDR"
  ];
  // Owner ruling 6 Oct 2026: the house name is set in Gallina as on the packaging,
  // but UPPERCASE (product names stay lowercase), so it gets its own class.
  var BRAND = "AZOURANE";
  var BRAND_CLASS = "az-brand";

  // Gallina for the house name: same theme asset the PDP and email use. Gallina is a light
  // display face, so it is nudged up in size and tracked out to sit level with body copy.
  (function injectBrandStyle() {
    if (document.getElementById("az-brand-style")) return;
    var src = (document.currentScript && document.currentScript.src) || "";
    var font = src ? src.replace(/az-name-walker\.js[^/]*$/, "az-gallina-20260803.woff2") : "";
    var css = (font ? "@font-face{font-family:'AZ Brand Gallina';src:url('" + font + "') format('woff2');font-weight:400;font-style:normal;font-display:swap}" : "") +
      ".az-brand{font-family:'AZ Brand Gallina','AZ Gallina',AZGallina,Georgia,serif;text-transform:uppercase;" +
      "font-weight:400;font-style:normal;letter-spacing:.06em;font-size:1.12em;line-height:1;white-space:nowrap}";
    var style = document.createElement("style");
    style.id = "az-brand-style";
    style.textContent = css;
    (document.head || document.documentElement).appendChild(style);
  })();

  var SKIP_TAGS = {
    SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, INPUT: 1,
    SELECT: 1, OPTION: 1, TITLE: 1, SVG: 1, CODE: 1
  };

  // Longest-first so e.g. TIFAWIN does not get partially eaten by TIFAWT logic.
  var sortedNames = NAMES.slice().sort(function (a, b) { return b.length - a.length; });
  var pattern = new RegExp("\\b(" + sortedNames.concat([BRAND]).join("|") + ")\\b", "gi");
  // Customer quotes keep their own words and look.
  var QUOTE_SELECTOR = "blockquote, q, [class*='review'], [class*='quote'], [class*='testimonial']";

  function alreadyWrapped(node) {
    var el = node.parentElement;
    while (el) {
      if (el.classList && (el.classList.contains("az-name") || el.classList.contains(BRAND_CLASS))) return true;
      if (SKIP_TAGS[el.tagName]) return true;
      el = el.parentElement;
    }
    return false;
  }

  function wrapTextNode(node) {
    var text = node.nodeValue;
    pattern.lastIndex = 0;
    if (!pattern.test(text)) return;
    pattern.lastIndex = 0;

    var frag = document.createDocumentFragment();
    var lastIndex = 0;
    var match;
    while ((match = pattern.exec(text)) !== null) {
      if (match.index > lastIndex) {
        frag.appendChild(document.createTextNode(text.slice(lastIndex, match.index)));
      }
      var span = document.createElement("span");
      var isBrand = match[0].toUpperCase() === BRAND;
      if (isBrand && node.parentElement && node.parentElement.closest(QUOTE_SELECTOR)) {
        frag.appendChild(document.createTextNode(match[0]));
        lastIndex = match.index + match[0].length;
        continue;
      }
      span.className = isBrand ? BRAND_CLASS : "az-name";
      span.textContent = match[0];
      frag.appendChild(span);
      lastIndex = match.index + match[0].length;
    }
    if (lastIndex < text.length) {
      frag.appendChild(document.createTextNode(text.slice(lastIndex)));
    }
    node.parentNode.replaceChild(frag, node);
  }

  function walk(root) {
    if (!root) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        if (!node.nodeValue || !/\S/.test(node.nodeValue)) return NodeFilter.FILTER_REJECT;
        var parentTag = node.parentElement ? node.parentElement.tagName : "";
        if (SKIP_TAGS[parentTag]) return NodeFilter.FILTER_REJECT;
        if (alreadyWrapped(node)) return NodeFilter.FILTER_REJECT;
        pattern.lastIndex = 0;
        if (!pattern.test(node.nodeValue)) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var nodes = [];
    var n;
    while ((n = walker.nextNode())) nodes.push(n);
    nodes.forEach(wrapTextNode);
  }

  function run() {
    walk(document.body);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }

  // Cart drawer / cart-notification content is re-rendered via innerHTML after
  // add-to-cart and quantity changes. Observe its container and re-walk only
  // the changed subtree so this stays cheap and idempotent.
  function observeCartRoots() {
    var ids = ["CartDrawer", "cart-notification", "CartDrawer-CartItems", "main-cart-items", "AZMiniCart"];
    ids.forEach(function (id) {
      var el = document.getElementById(id);
      if (!el || el._azNameObserved) return;
      el._azNameObserved = true;
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          m.addedNodes.forEach(function (added) {
            if (added.nodeType === 1) walk(added);
          });
        });
      });
      observer.observe(el, { childList: true, subtree: true });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", observeCartRoots);
  } else {
    observeCartRoots();
  }
})();
